import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Breadcrumb, Spin, Divider, Switch, message } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import AntdProForm, { ProFormText, ProFormSelect } from '@ant-design/pro-form';
import ProForm from '../../layout/ProForm';
import { useQuery, useMutation } from '@apollo/client';
import { UPDATE_FACULTY, GET_FACULTIES } from '../../../gql/faculties';
import DepartmentsList from './DeparementsList';
import { ENUM_FACULTY_CONTROL_TYPE } from 'constants/form';

const EditFaculty = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_FACULTIES, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [updateFaculty, { loading: updateFacultyLoading }] = useMutation(
    UPDATE_FACULTY,
    {
      refetchQueries: [
        { query: GET_FACULTIES, variables: { ids: [id], state: 'ALL' } },
        { query: GET_FACULTIES, variables: { ids: [id], state: 'ACTIVE' } },
      ],
      onCompleted: ({ updateFaculty }) => {
        message.success(`${updateFaculty.abbreviation} successfully edited`);
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  const [form] = AntdProForm.useForm();

  if (loading) {
    return (
      <PageContainer
        header={{
          title: 'Edit Faculty',
        }}
        loading
      />
    );
  }

  const faculty = data.faculties[0];

  return (
    <PageContainer
      header={{
        title: 'Edit Faculty',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/faculties">Faculties</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{faculty.abbreviation}</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Spin spinning={updateFacultyLoading} tip="Updating...">
        <ProForm
          form={form}
          onFinish={(input) => {
            updateFaculty({
              variables: {
                updateFacultyInput: {
                  id: id,
                  controlType: input.controlType,
                  disabled: !input.active,
                  deleted: faculty.deleted,
                  name: input.name,
                  abbreviation: input.abbreviation,
                },
              },
            });
          }}
          initialValues={{
            name: faculty.name,
            abbreviation: faculty.abbreviation,
            active: !faculty.disabled,
            controlType: faculty?.controlType,
          }}
        >
          <ProFormText
            width="xl"
            name="name"
            label="Name"
            placeholder="name"
            rules={[{ required: true, message: 'Please enter faculty name!' }]}
          />
          <ProFormText
            width="xl"
            name="abbreviation"
            label="Abbreviation"
            placeholder="abbreviation"
            rules={[
              {
                required: true,
                message: 'Please enter faculty abbreviation!',
              },
            ]}
          />
          <ProFormSelect
            width="xl"
            name="controlType"
            label="Control Type for Annual report reminder"
            rules={[{ required: true, message: 'Please select control type!' }]}
            valueEnum={ENUM_FACULTY_CONTROL_TYPE}
          />
          <AntdProForm.Item
            name="active"
            label="Active"
            valuePropName="checked"
          >
            <Switch />
          </AntdProForm.Item>
        </ProForm>
      </Spin>
      <Divider style={{ marginBottom: '48px' }} />
      <DepartmentsList departments={faculty.departments} id={id} />
    </PageContainer>
  );
};

export default EditFaculty;
